import GRAPHQL_CLIENT from "@/graphql/client";
import type {
  Product,
  GetProductByHandleQuery,
} from "@/graphql/storefront/generated";

export type ProductByHandle = NonNullable<
  GetProductByHandleQuery["productByHandle"]
>;

export async function getProductsByIds(
  productIds: string[],
): Promise<Product[]> {
  const { nodes } = await GRAPHQL_CLIENT.GetProductsByIds({
    ids: productIds,
  });

  return nodes.filter((n) => n != null) as Product[];
}

export async function getProductById(productId: string): Promise<Product> {
  const { node } = await GRAPHQL_CLIENT.GetProductById({
    id: productId,
  });
  if (!node) {
    throw new Error(`No product found for id ${productId}`);
  }
  return node as Product;
}
